import React from 'react';
export const OptionLayoutSkeleton = ({ showLabel = true }) => (React.createElement("div", { className: "m:6 skeleton" },
    React.createElement("div", { className: "bdrs:1 bd bd:w:1 bd:c:border-0.2 pt:8 pb:6 pt:10:xl-up w:64 w:72:xl-up" },
        React.createElement("span", { className: "d:inline-block h:32 h:36:xl-up w:44 w:48:xl-up" }),
        showLabel && React.createElement("span", { className: "d:block h:24 h:32:xl-up w:44 w:48:xl-up" }))));
